import React, { Component } from 'react';
import classes from './FrontPage.module.css';
import LearningTile from '../../components/LearningTile/LearningTile';

import videoDataList from '../../assets/json/data.json';

class FrontPage extends Component {
    state = {}

    getTiles() {
        let tileList = [];
        if (videoDataList) {

            for (let videoData of videoDataList.data) {
                tileList.push(
                    <LearningTile key={videoData.id} title={videoData.title} slug={videoData.slug} buttonTitle={videoData.btnTitle} entryID={videoData.id} />
                )

            }
        }
        return tileList;
    }
    render() {
        return (
            <div className={classes.FrontPage}>
                <h1 className={classes.Headline}>Schulungsfilm zur Händedesinfektion</h1>
                <div className={classes.TileWrapper}>
                    {this.getTiles()}
                </div>
            </div>);
    }
}

export default FrontPage;